import { render, staticRenderFns } from "./SpeedStatsItem.vue?vue&type=template&id=5ceef978&scoped=true"
import script from "./SpeedStatsItem.vue?vue&type=script&lang=js"
export * from "./SpeedStatsItem.vue?vue&type=script&lang=js"
import style0 from "./SpeedStatsItem.vue?vue&type=style&index=0&id=5ceef978&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceef978",
  null
  
)

export default component.exports